import { Cache } from 'aws-amplify';
import * as data from '@sendpayments/js-utils/dist/const/defaults';

// DEPRECATED, DO NOT USE
export const getAppConfig = () => {
  const appConfig = Cache.getItem('settings') || {};
  return { ...data, ...appConfig };
};
